import React from 'react';
import ReactDOM from 'react-dom/client';
import './gdy-index.css';
import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('my-react-plugin-root'));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

